export default function initTrackingForProgrammaticSections() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const type = entry.target.getAttribute('data-section-type');
        const header = entry.target.querySelector('h2').innerText;

        App.track.event('location_page_interaction', {
          section: 'programmatic_section',
          element: type,
          element_value: header,
          interaction: 'visible',
        });

        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.5,
  });

  document.querySelectorAll('.p-hire-additional-section').forEach(section => {
    // room-card
    section.querySelectorAll('.c-room-card').forEach(roomCard => {
      roomCard.addEventListener('click', () => {
        const type = section.getAttribute('data-section-type');

        App.track.event('location_page_interaction', {
          section: 'programmatic_section',
          element: type,
          element_value: 'room_card',
          interaction: 'click',
        });
      });
    });

    // show all button
    section.querySelector('.js-show-all-additional-rooms-section').addEventListener('click', () => {
      const type = section.getAttribute('data-section-type');

      App.track.event('location_page_interaction', {
        section: 'programmatic_section',
        element: type,
        element_value: 'show_all',
        interaction: 'click',
      });
    });

    // slider arrows (.c-box-carousel-arrow)
    section.querySelectorAll('.c-box-carousel-arrow').forEach(arrow => {
      arrow.addEventListener('click', () => {
        const type = section.getAttribute('data-section-type');

        App.track.event('location_page_interaction', {
          section: 'programmatic_section',
          element: type,
          element_value: 'slider_arrow',
          interaction: 'click',
        });
      });
    });

    observer.observe(section);
  });
}
